<template>
  <DialogCard>
    <template #title>
      Scientists
    </template>
    <template #text>
      <p>
        Let us leverage the millions of medical images to accelerate research.
      </p>
      <ul>
        <li>
          The neuralike platform changes the paradigm of healthcare by putting the consumer in the
          driving seat. This allows us to build a very large database of medical images that can
          enable important research projects and make a true impact.
        </li>
        <li>
          Many neuralike users are interested in actively contributing to ongoing research projects.
          We can help researchers in gathering complimentary data that are virtually impossible to
          obtain otherwise.
        </li>
        <li>
          We are committed to the highest scientific standards and strive to become the trusted
          source of information on medical images.
        </li>
        <li>
          We seek partnerships with academic institutions, companies, and nonprofits that are
          dedicated to garner new insights into diagnosis and treatments of disease. Interested?
          <a>Send us a message</a> and we’ll get right back to you.
        </li>
      </ul>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'NeuralikeScientistsDialog',
  components: {
    DialogCard,
  },
};
</script>
